<template>
  <VirtualScrollbar>
    <div
      class="room_group_cells"
      :class="{ room_group_cells_small: foldedStatus }"
    >
      <div class="room_group_cell">
        <div class="room_cells">
          <div
            v-for="(items, indexs) in circleList"
            :key="indexs"
            class="room_cell can"
            :class="{ room_cell_active: items.uid == currentCircleId }"
            @click="selectCircle(items, indexs)"
          >
            <div class="room_avatar_box pr flex jc_c">
              <img class="room_avatar" :src="items.avatar" alt="" />
              <img
                v-if="items.live_room_status"
                class="icon_zhibozhong"
                src="@/assets/img/circleV2/icon_zhibozhong.gif"
                alt=""
              />
              <div v-if="items.unread_num" class="red_point">
                {{ items.unread_num > 99 ? "99" : items.unread_num }}
              </div>
            </div>
            <div v-if="!foldedStatus">
              <div class="name">
                {{ items.title }}
              </div>
              <div class="desc hang1">
                <div v-if="items.info.content" v-html="items.info.content" />
                <template v-else>
                  {{ items.sub_title }}
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </VirtualScrollbar>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      circleList: [],
      currentCircleId: null,
    };
  },
  props: {
    foldedStatus: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async getCircleList() {
      const res = await request.post("/teacher/circle/getCircleList");
      const circleList = res.data;
      for (const item of circleList) {
        if (item.info.content) {
          item.info.content = this.emojiReplace(item.info.content, true);
        }
      }
      this.circleList = res.data;
    },
    selectCircle(e, indexs) {
      this.currentCircleId = e.uid;
      this.$parent.getCircleConfig({
        circle_id: e.uid,
        teacher_id: null,
      });
      this.circleList[indexs].unread_num = 0;
    },
    updateNewMessage(data) {
      const circleList = this.circleList;
      for (const items of circleList) {
        if (data.to_user_id * 1 === items.uid * 1) {
          items.info.content = this.emojiReplace(data.content, true);
          if (items.uid * 1 !== this.currentCircleId) {
            items.unread_num++;
          } else {
            // this.readChat(items.uid)
          }
          break;
        }
      }
    },
    // async readChat (uid) {
    //   await request.post('/api/chat/readChat', {
    //     uid,
    //     chat_type: 4
    //   })
    // }
  },
};
</script>

<style scoped>
.room_group_cells {
  box-sizing: border-box;
  padding: 16px 0;
}

.group_name {
  height: 37px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  box-sizing: border-box;
  padding: 0 16px;
}

.room_cells {
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.room_cell {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 8px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  border: 1px solid transparent;
}

.room_cell:hover {
  border-color: #eeeeee;
}

.room_cell_active {
  background-color: #f6f6f6;
}

.room_avatar_box {
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 8px;
}

.room_avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid #eee;
  flex-shrink: 0;
  object-fit: cover;
}

.icon_zhibozhong {
  position: absolute;
  top: 36px;
  height: 20px;
  display: block;
}

.red_point {
  position: absolute;
  right: 0;
  top: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #e83e3e;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.room_cell .name {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.room_cell .desc {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 6px;
}

.room_cell .desc >>> p {
  margin: 0;
}

.btn_join {
  margin-top: 10px;
  width: 77px;
  height: 23px;
  line-height: 23px;
  background: #4571e7;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.room_group_cells_small /deep/.room_cell {
  padding: 6px;
}

.room_group_cells_small /deep/.room_avatar_box {
  margin-right: 0;
}

.room_group_cells_small /deep/.room_avatar {
  width: 48px;
  height: 48px;
  display: block;
}
</style>
